// ********************************************************************************
// IMPORTS
import { change, untouch } from 'redux-form';

import store from '../../store'; // Import global store

import {
  createSession
} from '../../../features/auth/AuthActions';

import history from './history';

const CDNPATH = 'https://s.freecharge.in/content/images/accountui/';

/**
 * =============================== TABLE OF CONTEXT ===============================
 * NOTE: Please add function name followed by a colon and description in this TOC,
 * Also, don't forget to export the function at the bottom of the .js file.
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * 1. dispatchCreateSession: Helper to create session
 * 2. goBack: goBack in router history
 * 3.1 historyRedirect: redirect using history
 * 4. exportCSVFile: generator CSV from JSON and download the statement
 * 5. maxLength: maxLength for TextInput
 * 6. toTitleCase: Convert any string to title case (first letter to upper case)
 * 7. getCookie: Get a cookie by name
 * 8. popupwindow: open url in pop window
 * 9. getCDNpath: get the CDN path from given path
 * 10. isUserLoggedIn: check if user is logged in
 * 11. isProduction: check if the environment is production
 * 12. resetReduxFormField: reset fields [Array] in redux form
 * 13. ghostForm: Create a form and insert into document and submit the form
 * 14. bankMapping: Bank code mapping
 * 15. getErrorMessage: Error message mapping
 * ================================================================================
 */

// dispatch createSession
const dispatchCreateSession = (callback) => {
  store.dispatch(createSession());

  if (!!callback && typeof callback === 'function') {
    callback();
  }
};
// ********************************************************************************

const goBack = () => {
  const { push } = history;
  const pathname = getLocalstorageItem('currentpathname');
  if (pathname) {
    push(pathname);
  } else {
    push('/accounts/dashboard');
  }
}

// ********************************************************************************

const historyRedirect = (url) => {
  history.push(url);
};

// ********************************************************************************

function convertToCSV(objArray) {
  var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
  var str = '';

  for (var i = 0; i < array.length; i++) {
    var line = '';
    for (var index in array[i]) {
      if (line !== '') line += ','

      line += array[i][index];
    }

    str += line + '\r\n';
  }

  return str;
}

function exportCSVFile(headers, items, fileTitle, callback) {
  if (headers) {
    items.unshift(headers);
  }

  // Convert Object to JSON
  var jsonObject = JSON.stringify(items);

  var csv = convertToCSV(jsonObject);

  var exportedFilenmae = fileTitle + '.csv' || 'export.csv';

  var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  if (navigator.msSaveBlob) { // IE 10+
    navigator.msSaveBlob(blob, exportedFilenmae);
  } else {
    var link = document.createElement("a");
    if (link.download !== undefined) { // feature detection
      // Browsers that support HTML5 download attribute
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", exportedFilenmae);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      callback();
    }
  }
}


// ********************************************************************************

const maxLength = max => value => {
  let v;
  let result = value.length > max;

  if (result === false) {
    v = value;
  }
  return v;
};

// ********************************************************************************

const toTitleCase = (str) => {
  if (!str) return "";
  return str.replace(
    /\w\S*/g,
    function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    }
  );
}

// ********************************************************************************

const getCookie = (name) => {
  var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) return match[2];
}

// ********************************************************************************

const popupwindow = (url, title, win, w, h) => {
  const y = win.top.outerHeight / 2 + win.top.screenY - (h / 2)
  const x = win.top.outerWidth / 2 + win.top.screenX - (w / 2)
  return win.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + y + ', left=' + x);
}

// ********************************************************************************

const getCDNpath = path => (CDNPATH + path);

// ********************************************************************************

const isUserLoggedIn = () => ((store.auth.isLoggedIn && store.auth.isLoggedIn.result) || false);

// ********************************************************************************

const isProduction = () => {
  try {
    const hostname = window.location.hostname.split('.');
    if (hostname[hostname.length - 1] === 'in' && hostname[hostname.length - 2] === 'freecharge' && window.location.hostname.indexOf("ext-") === -1) {
      return true;
    } else {
      return false;
    }
  } catch (e) {
    console.log('Error from util function isProduction', e);
    return false;
  }
}

// ********************************************************************************

/**
 * Reset fields in given redux form
 * @param formName <String> redux form name in string
 * @param fieldsObj <Array> array fields to reset in the given form
 */
const resetReduxFormField = (formName, fieldsObj, props) => {
  Object.keys(fieldsObj).forEach(fieldKey => {

    //reset the field's value
    props.dispatch(change(formName, fieldKey, fieldsObj[fieldKey]));

    //reset the field's error
    props.dispatch(untouch(formName, fieldKey));

  });
};

// ********************************************************************************
/**
 * Create a form and insert into document and submit the form
 * @param {string} url 
 * @param {object} data 
 * @param {array} attrib_exception
 */
const ghostForm = (url, data, attrib_exception) => {
  // optional step, check if server. if SSR implemented in future
  if (!document || !window.document) return;

  const _d = document || window.document;

  const form = _d.createElement('form');

  form.method = 'POST';
  form.action = url;

  if (data) {
    for (var attrib in data) {
      if (attrib_exception.indexOf(attrib) !== -1) continue;

      const element = _d.createElement('input');

      element.type = 'hidden';
      element.value = data[attrib];
      element.name = attrib;

      form.append(element);
    }
  }

  _d.body.appendChild(form);

  // submit the form
  form.submit();
}

const setLocalStorageItem = (key, value) => {
  if (window.localStorage) {
    localStorage.setItem(key, value);
    return true;
  } else {
    return false;
  }
}

const getLocalstorageItem = (key) => {
  if (window.localStorage) {
    return localStorage.getItem(key);
  } else {
    return false;
  }
}

const bankMapping = bankCode => {
  const map = {
    ALLB: "Allahabad Bank",
    ANDB: "Andhra Bank",
    AXIS: "AXIS",
    BAHK: "Bank of Bahrain and Kuwait",
    BOBC: "Bank of Baroda - Corporate Banking",
    BOBR: "Bank of Baroda - Retail Banking",
    BOI: "Bank of India",
    CANB: "Canara Bank",
    CENB: "Central Bank of India",
    CITA: "CITIBANK",
    CITU: "City Union Bank",
    CORB: "Corporation Bank",
    CSYB: "Catholic Syrian Bank",
    DECB: "DCB BANK LIMITED",
    DENB: "Dena Bank",
    DEUB: "Deutsche Bank",
    DHLB: "Dhanlaxmi Bank",
    FEDB: "Federal Bank",
    HDFC: "HDFC",
    ICIC: "ICICI",
    IDBI: "IDBI",
    INDB: "Indian Bank",
    INIB: "IndusInd Bank",
    INVB: "ING Vysya Bank",
    IOB: "Indian Overseas Bank",
    JNKB: "Jammu & Kashmir Bank",
    KARB: "Karur Vysya Bank",
    KOBK: "KOTAK",
    KRTB: "Karnataka Bank Ltd",
    LXCB: "Laxmi Vilas Bank - Corporate Net Banking",
    LXRB: "Laxmi Vilas Bank - Retail Net Banking",
    MAHB: "Bank of Maharashtra",
    ORTB: "Oriental Bank of Commerce",
    PJCB: "Punjab National Bank - Corporate Banking",
    PJRB: "Punjab National Bank - Retail Banking",
    PJSB: "Punjab & Sind Bank",
    RATB: "Ratnakar Bank",
    SBIN: "SBI",
    SBJB: "State Bank of Bikaner & Jaipur",
    SHVB: "Shamrao Vitthal Co-operative Bank",
    SHYB: "State Bank of Hyderabad",
    SINB: "South Indian Bank",
    SMYB: "State Bank of Mysore",
    SPTB: "State Bank of Patiala",
    STCB: "Standard Chartered Bank",
    STVB: "State Bank of Travancore",
    SYNB: "Syndicate Bank",
    TMEB: "Tamilnad Mercantile Bank Ltd.",
    UBI: "Union Bank Of India",
    UCOB: "UCO Bank",
    UNIB: "United Bank of India",
    VIJB: "Vijaya Bank",
    YEBK: "YES BANK"
  };

  return map[bankCode];
}

const getErrorMessage = (e) => {
  e = e ? e : "";
  const a = {
      "ER-1001": "Sorry, our system seems to be acting up. Can you please try again?",
      "ER-1002": "Sorry, seems like an incorrect email address",
      "ER-1004": "Please enter your mobile number",
      "ER-1005": "Sorry, seems like an incorrect mobile number",
      "ER-1006": "Sorry, a FreeCharge account already exists with this phone number",
      "ER-1007": "Please enter your password",
      "ER-1008": 'Password entered is not valid, avoid using &*+|;"<>,',
      "ER-1009": "Please enter your name",
      "ER-1010": 'First name entered is not valid, avoid using numbers &*+|;"<>,',
      "ER-1011": 'Middle name entered is not valid, avoid using numbers &*+|;"<>,',
      "ER-1012": 'Last name entered is not valid, avoid using numbers &*+|;"<>,',
      "ER-1014": "Sorry, our system seems to be acting up. Can you please try again?",
      "ER-1015": "Sorry, our system seems to be acting up. Can you please try again?",
      "ER-1018": "Please enter your password",
      "ER-1019": 'Password entered is not valid, avoid using &*+|;"<>,',
      "ER-1022": "Sorry, our system seems to be acting up. Can you please try again?",
      "ER-1023": "Sorry, our system seems to be acting up. Can you please try again?",
      "ER-1024": "Sorry, our system seems to be acting up. Can you please try again?",
      "ER-1025": "Sorry, our system seems to be acting up. Can you please try again?",
      "ER-1026": "Sorry, our system seems to be acting up. Can you please try again?",
      "ER-1027": "Sorry, seems like your old password is incorrect",
      "ER-1029": "Sorry, the password must differ from the old password.",
      "ER-1032": "Sorry, our system seems to be acting up. Can you please try again?",
      "ER-1033": "Sorry, our system seems to be acting up. Can you please try again?",
      "ER-1036": "Name should not exceed 50 characters",
      "ER-1037": "Sorry, our system seems to be acting up. Can you please try again?",
      "ER-1039": "Sorry, our system seems to be acting up. Can you please try again?",
      "ER-1040": "Sorry, our system seems to be acting up. Can you please try again?",
      "ER-2002": "Sorry, seems like you have been logged out. Please sign in again to continue.",
      "ER-2005": "Sorry, our system seems to be acting up. Can you please try again?",
      "ER-3001": "Sorry, our system seems to be acting up. Can you please try again?",
      "ER-3002": "Sorry, our system seems to be acting up. Can you please try again?",
      "ER-3003": "Please enter the 4 digit confirmation code",
      "ER-3004": "Sorry, the confirmation code is incorrect",
      "ER-3005": "You have exceeded the maximum limit of OTPs. Please try after 5 minutes."
  }
    , n = a[e] ? a[e] : "Sorry, our system seems to be acting up. Can you please try again?";
  return n
}

// const textSecuritySupported = () => {
//   var x = document.getElementsByTagName("input")[0];
//   var style = window.getComputedStyle(x);

//   if (style.webkitTextSecurity) {
//     return true;
//   } else {
//     return false;
//   }
// }

// EXPORTS
export {
  store,
  dispatchCreateSession,
  getCookie,
  goBack,
  historyRedirect,
  maxLength,
  toTitleCase,
  exportCSVFile,
  popupwindow,
  getCDNpath,
  isUserLoggedIn,
  isProduction,
  resetReduxFormField,
  ghostForm,
  setLocalStorageItem,
  getLocalstorageItem,
  bankMapping,
  getErrorMessage,
};

// ********************************************************************************